/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Field } from 'react-final-form';
import { css, StyleSheet } from 'aphrodite';
import { InputContainer, Text } from '@blend/enterprise-components';
import { omit } from 'lodash';

import { BlendBridge } from 'blb-types/blendBridge';
import { respondToAuthChallenge } from 'blb-api/auth';
import { FormCard } from 'blb-components/FormCard';
import { PasswordValidity } from 'blb-components/UnauthenticatedApp/PasswordValidity';
import { useChallengeCookie, useLoginFlowSubmit } from 'blb-utils/login';
import { SetUser } from 'blb-ui-types/login';

import { passwordInputConfigWithValidation, confirmPasswordInputConfig } from 'blb-inputs/unauthenticated';
import { complianceInput } from './inputConfigs';

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  spacer: {
    ':not(:last-child)': {
      marginBottom: 24,
    },
  },
});

export namespace UpdatePasswordChallengePage {
  export interface Props {
    setMe: SetUser;
  }
}

type FormValues = BlendBridge.API.UpdatePasswordChallenge & {
  confirmedPassword: string;
};

export const UpdatePasswordChallengePage: React.FC<UpdatePasswordChallengePage.Props> = ({ setMe }) => {
  const challengeCookieResult = useChallengeCookie();
  const { username } = challengeCookieResult.cookie as BlendBridge.API.UpdatePasswordChallengeCookie;
  const formValuesTransformer = (formValues: FormValues) => {
    return { ...omit(formValues, ['confirmedPassword']) };
  };
  const onSubmit = useLoginFlowSubmit(respondToAuthChallenge, setMe, formValuesTransformer);

  return (
    <FormCard<FormValues>
      headerTitle="Let's activate your account."
      id="UpdatePasswordChallenge"
      onSubmit={onSubmit}
      submitLabel="Activate account"
    >
      <div className={css(styles.spacer)}>
        <InputContainer
          customComponentProps={{ children: username }}
          input={{ name: 'email' }}
          inputComponent={Text}
          label="Email"
          labelSize="sm"
          meta={{} as any}
        />
      </div>
      <Field {...passwordInputConfigWithValidation} />
      <Field {...confirmPasswordInputConfig} />
      <PasswordValidity />
      <div className={css(styles.spacer)}>
        <Field {...complianceInput} />
      </div>
    </FormCard>
  );
};
